import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as configActions } from '../../../store/ducks/config-section';

import { EntregaRetirada } from './EntregaRetirada';
import { TIPO_ENTREGA_RETIRADA } from '../../../constants/configuracao-horarios';
import { Header } from '../styles';

import { ConfiguracaoHorarioContainer, ContentContainer } from './styles';

import { Tab, TabText } from '../styles';

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...configActions
        },
        dispatch
    );

const mapStateToProps = ({ section }) => {
    return {
        section
    };
};

export const HorarioFuncionamento = connect(
    mapStateToProps,
    mapDispatchToProps
)(({ section, selectTab }) => {
    return (
        <ConfiguracaoHorarioContainer>
            <ContentContainer>
                <Header>
                    <Tab
                        isSelected={
                            section.idTipoEntregaRetirada ===
                            TIPO_ENTREGA_RETIRADA.RETIRADA
                        }
                        onClick={() => {
                            selectTab({
                                idTipoEntregaRetirada:
                                    TIPO_ENTREGA_RETIRADA.RETIRADA
                            });
                        }}
                    >
                        <TabText
                            isSelected={
                                section.idTipoEntregaRetirada ===
                                TIPO_ENTREGA_RETIRADA.RETIRADA
                            }
                        >
                            Retirada
                        </TabText>
                    </Tab>
                    <Tab
                        isSelected={
                            section.idTipoEntregaRetirada ===
                            TIPO_ENTREGA_RETIRADA.ENTREGA
                        }
                        onClick={() => {
                            selectTab({
                                idTipoEntregaRetirada:
                                    TIPO_ENTREGA_RETIRADA.ENTREGA
                            });
                        }}
                    >
                        <TabText
                            isSelected={
                                section.idTipoEntregaRetirada ===
                                TIPO_ENTREGA_RETIRADA.ENTREGA
                            }
                        >
                            Entrega
                        </TabText>
                    </Tab>
                </Header>
                <EntregaRetirada
                    idTipoEntregaRetirada={section.idTipoEntregaRetirada}
                />
            </ContentContainer>
        </ConfiguracaoHorarioContainer>
    );
});
